// Map raw geometry metric values to 0–100 scores (pipeline Stage 6, geometry
// side) via a Gaussian decay peaking at the literature ideal:
//
//   score = 100 * exp( -((value - ideal) / tolerance)^2 )
//
// A score at/above STRONG_THRESHOLD reads "strong"; below reads "addressable".
// These scores are a DIAGNOSTIC overlay — never the headline verdict.
import { METRICS, STRONG_THRESHOLD } from './constants';

export function gaussianScore(value, ideal, tolerance) {
  if (typeof value !== 'number' || !Number.isFinite(value)) return null;
  if (!tolerance) return null;
  const z = (value - ideal) / tolerance;
  return 100 * Math.exp(-(z * z));
}

// Score one metric by key. Returns { key, label, value, score, band } or null
// when the raw value is unavailable.
export function scoreMetric(key, value) {
  const spec = METRICS[key];
  if (!spec) return null;
  const score = gaussianScore(value, spec.ideal, spec.tolerance);
  if (score == null) return null;
  const rounded = Math.round(score);
  return {
    key,
    label: spec.label,
    value: Math.round(value * 1000) / 1000,
    score: rounded,
    band: rounded >= STRONG_THRESHOLD ? 'strong' : 'addressable',
  };
}
